import React from "react";

/**
 * Clean multicolor Google "G" mark — official brand colors.
 * Used inside the "Sign in with Google" button.
 */
export const GoogleIcon = ({ size = 18, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
    aria-hidden
    focusable="false"
  >
    <path
      fill="#EA4335"
      d="M12 10.2v3.9h5.5c-.24 1.4-1.7 4.1-5.5 4.1-3.3 0-6-2.7-6-6.2s2.7-6.2 6-6.2c1.9 0 3.2.8 3.9 1.5l2.7-2.6C16.9 3.2 14.7 2 12 2 6.9 2 2.8 6.1 2.8 11.2S6.9 20.4 12 20.4c6.9 0 9.4-4.8 9.4-7.3 0-.5-.1-.9-.1-1.3H12z"
    />
    <path
      fill="#4285F4"
      d="M21.3 11.8c0-.5-.1-.9-.1-1.3H12v3.9h5.5c-.24 1.4-1 2.5-2 3.3l3.2 2.5c1.9-1.7 3-4.3 3-7.4z"
    />
    <path
      fill="#FBBC05"
      d="M6.4 14.2c-.3-.7-.4-1.4-.4-2.2s.2-1.5.4-2.2L3.2 7.4C2.4 8.9 2 10.5 2 12s.4 3.1 1.2 4.6l3.2-2.4z"
    />
    <path
      fill="#34A853"
      d="M12 22c2.7 0 5-.9 6.6-2.5l-3.2-2.5c-.9.6-2 1-3.4 1-2.6 0-4.8-1.7-5.6-4.1L3.2 16.4C4.8 19.7 8.1 22 12 22z"
    />
  </svg>
);

export default GoogleIcon;
